var React = require('react');

function ThirdPartyFilterIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.01309 8.79977L16.0065 4L26.9984 8.79977L26.9989 8.85353C27.0098 9.9183 27.1314 21.823 16.0047 28C4.61289 21.914 4.96781 10.3026 5.01026 8.91385C5.0119 8.86036 5.01307 8.82203 5.01309 8.79977ZM16.0065 5.09117L25.9941 9.45237C25.9256 12.0485 25.0928 21.5004 15.9952 26.8537C6.52789 21.4969 5.99331 12.0706 6.00098 9.45961L16.0065 5.09117ZM16 7V24.5C18.5 23 23.6 18.1 24 10.5L16 7Z","fill":"white"}));
}

ThirdPartyFilterIcon.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = ThirdPartyFilterIcon;

ThirdPartyFilterIcon.default = ThirdPartyFilterIcon;
